import React from 'react';
import './google-signin-button.scss';
import GoogleLoginOrSignup from './google-login-or-signup';

export default function GoogleSignInButtonWrapper(props) {
  return <GoogleLoginOrSignup {...props} />;
}
